import { isArray, isEmpty, deepCopy, clearTagOfData, getKeyOfData } from '@/common/js/utils'
import { getConvert } from '@/api/baidu.model'
import { checkPlanName } from '@/api/common.model'

let Timer
const dynwords = ['日期', '时间', '定向包名', '创意组名', '账号简称']

export default {
  computed: {},
  data() {
    return {
      show: null,
      check: null, // 计划名检查
      dynErr: '',
      dynpos: [], // 动态词位置
      dynwords: dynwords, // 动态词
      convertModel: null,
      linkModel: null,

      gameData: [], // 常用游戏数据源
      agentData: [], // 人员数据源
      targetPlan: [] // 定向列表
    }
  },
  methods: {
    focusPlan() {
      Timer && clearTimeout(Timer)
    },
    blurPlan() {
      Timer = setTimeout(() => {
        this.checkPlan()
      }, 1000)
    },
    checkPlan() {
      const plan_name = deepCopy(this.plan.plan_name)
      if (isEmpty(plan_name)) return
      this.check = 'loading'
      checkPlanName({ planName: plan_name })
        .then((data) => {
          this.check = data ? 'success' : 'error'
        })
        .catch(() => {
          this.check = 'error'
        })
    },
    // 添加动态词
    appendTrend(word) {
      const title = deepCopy(this.plan.plan_name)
      const { selectionStart } = this.$refs.planinput[0].$refs.input.$refs.input
      const prefix = title.substring(0, selectionStart)
      const suffix = title.substring(selectionStart)
      if (title.indexOf(word) > -1) {
        this.$Message.error('不能使用重复的动态词')
        return
      }
      this.plan.plan_name = `${prefix}{${word}}${suffix}`
      this.validTrend()
      this.$refs.planinput[0].focus()
    },
    // 动态词验证
    validTrend() {
      const plan_name = deepCopy(this.plan.plan_name)
      if (isEmpty(plan_name)) return
      let dynErr = ''
      const regexp = /({[\u4e00-\u9fa5]{2,}})/g
      const values = plan_name.match(regexp)
      const count = (str, cut) => {
        if (typeof str !== 'string') return 0
        return str.split('').filter((ret) => ret === cut).length
      }
      if (count(plan_name, '{') !== count(plan_name, '}')) {
        dynErr = '动态词包格式错误'
      } else if (plan_name.replace(regexp, '').includes('{') || plan_name.replace(regexp, '').includes('{')) {
        dynErr = '动态词包标识{}不允许作为内容出现'
      } else if (isArray(values) && values.some((ret) => !this.dynwords.map((met) => `{${met}}`).includes(ret))) {
        dynErr = '动态词包不存在'
      } else if (isArray(values) && values.some((ret, i) => values.indexOf(ret) !== i)) {
        dynErr = '动态词包不能存在相同'
      }
      // 动态词位置
      let dynPos = []
      if (isArray(values)) {
        dynPos = values
          .filter((ret) => this.dynwords.map((met) => `{${met}}`).includes(ret))
          .map((m) => {
            const min = plan_name.indexOf(m)
            return [min, min + m.length]
          })
      }
      console.log('dynPosdynPos output: ', dynPos)
      this.dynpos = dynPos
      this.dynErr = dynErr
    },
    /**
     * @description: 小程序根据账号获取转化名称
     * @param {*} ad_account_id
     * @return {*}
     */
    getConvertByAccount(ad_account_id) {
      getConvert({ transFrom: 7, ad_account_id }).then((data) => {
        this.miniProgramTransList = data
      })
    },
    platformChange(val) {
      this.targetPlan.forEach((ret) => {
        if (val === 3) {
          // 操作系统定向切换到不限
          this.$set(ret.targetingParam, 'device', '0')
        } else {
          this.$set(ret.targetingParam, 'device', val === 2 ? '1' : '2')
        }
      })
      this.plan.game_id = ''
      this.plan.package = ''
      this.plan.game_address = ''

      // 如果是小程序类型，[使用系统内部落地页]默认不勾选
      if (val === 3) {
        this.plan.innerUrl = false

        // 转化类型切换到登录
        this.plan.transType = 49

        if (this.isLink) {
          this.getConvertByAccount(this.adAccount)
        }
      } else {
        this.plan.innerUrl = true
        this.plan.lpUrl = ''
        // 转化类型切换到激活
        this.plan.transType = 4
      }
    },
    handleGame(meta) {
      this.plan.game_id = meta.id
      this.plan.package = meta.ad_package // 更改成显示包名
      this.plan.game_address = meta.game_address
      if (this.isAndroid) {
        if (isArray(meta.sdks) && meta.sdks.includes('2008')) this.plan.callback_switch = 0
        else this.plan.callback_switch = 1
      }
    },
    // 代投账号
    changeAgent(val) {
      if (val === 'AGENT') this.plan.proxy_account_id = ''
      else this.plan.proxy_account_id = undefined
    },
    // 选择代投账号
    handleAgent(meta) {
      this.plan.proxy_account_id = meta.id
    },
    // 选择落地页回调
    selectLinkLandPage(data) {
      this.plan.page_addr = data.page_addr
      this.plan.land_page_id = data.land_page_id
      this.linkModel = false
    },
    // 选择计划管家回调
    appendButler(val) {
      this.plan.managePlan = val
    },
    // 删除自动化规则
    delMonitor(id) {
      const index = this.plan.monitorPlan.findIndex((ret) => ret.id === id)
      if (index > -1) this.plan.monitorPlan.splice(index, 1)
    },
    // 添加自动化规则回调
    appendMonitor(val) {
      this.$set(this.plan, 'monitorPlan', val)
    },
    // 多选卡还原默认值
    multRadioChange(val, mult) {
      if (val === 'NONE') this.plan[mult] = JSON.parse(JSON.stringify([]))
    },
    radioChange(defautData) {
      clearTagOfData(this.curTarget.data[defautData], this)
    },
    // 还原选择
    decompile(Ids, data) {
      const deepSelect = (item) => {
        item.forEach((ret) => {
          if (ret && ret.children && ret.children.length) deepSelect(ret.children)
          !ret.disabled && this.$set(ret, 'check', true)
        })
      }
      if (isArray(Ids) && Ids.length) {
        Ids.forEach((ret) => {
          const item = getKeyOfData(data, 'id', Number(ret))
          deepSelect([item])
        })
      }
    }
  }
}
